import { Navigate, useLocation } from "react-router-dom";
import { Suspense } from "react";
import { getSessionData } from "../../utils/interceptors/localStorageService";
import LoadingPage from "../../shared/common/Loader";
import UltimateAgentLayout from "../../pages/UltimateAgent/layout/UltimateAgentLayout";

/**
 * Wraps UltimateAgent routes with auth guard and the dedicated UA sidebar layout.
 * Bypasses InnerLayout so the UA module gets its own full-screen navigation.
 */
const UltimateAgentProtectedLayout = () => {
  const sessionData = getSessionData();
  const location = useLocation();

  if (!sessionData) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return (
    <Suspense fallback={<LoadingPage />}>
      <UltimateAgentLayout />
    </Suspense>
  );
};

export default UltimateAgentProtectedLayout;
